
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("5fYXL", function(module, exports) {

$parcel$export(module.exports, "useIsDropdownOpen", () => $00afeaf6fc3b48d5$export$f23a75298e125425);
$parcel$export(module.exports, "default", () => $00afeaf6fc3b48d5$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dPMMf = parcelRequire("dPMMf");

var $6d9QY = parcelRequire("6d9QY");

var $cNe2t = parcelRequire("cNe2t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $bbdV2 = parcelRequire("bbdV2");

var $ciFJV = parcelRequire("ciFJV");

var $cBavF = parcelRequire("cBavF");

var $iomkm = parcelRequire("iomkm");
const $00afeaf6fc3b48d5$export$f23a75298e125425 = (isOpen = false)=>(0, $eJOHy.useState)(isOpen);
const $00afeaf6fc3b48d5$var$entryPointParams = {};
const $00afeaf6fc3b48d5$var$CreatePullRequestDropdown = ({ createPullRequestTargets: createPullRequestTargets, renderDropdownTrigger: renderDropdownTrigger, onOpenDropdown: onOpenDropdown, hasErrors: hasErrors, onAuthErrorClick: onAuthErrorClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = $00afeaf6fc3b48d5$export$f23a75298e125425();
    const wasOpen = (0, $6d9QY.usePreviousWithInitial)(isOpen);
    (0, $eJOHy.useEffect)(()=>{
        if (wasOpen !== isOpen) {
            isOpen && (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdown opened', 'createPullRequestDropdown');
            !isOpen && (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'dropdown closed', 'createPullRequestDropdown');
            onOpenDropdown && onOpenDropdown({
                isOpen: isOpen
            });
        }
    }, [
        createAnalyticsEvent,
        wasOpen,
        isOpen,
        onOpenDropdown
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $iomkm.createPullRequestDropdownContentEntrypoint), $00afeaf6fc3b48d5$var$entryPointParams);
    const triggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            createPullRequestTargets: createPullRequestTargets,
            hasErrors: hasErrors,
            onAuthErrorClick: onAuthErrorClick,
            setIsOpen: setIsOpen
        }), [
        hasErrors,
        createPullRequestTargets,
        onAuthErrorClick,
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cNe2t.JiraPopup), {
        id: "create-pull-request-dropdown",
        testId: "development-summary-pull-request.ui.create-pull-request-summary-item.create-pull-request-dropdown.popup",
        messageId: "development-summary-pull-request.ui.create-pull-request-summary-item.create-pull-request-dropdown.popup",
        messageType: "transactional",
        zIndex: (0, $dPMMf.layers).modal + 1,
        placement: "bottom-end",
        shouldFlip: true,
        trigger: (triggerProps)=>renderDropdownTrigger({
                ...triggerProps,
                ref: (element)=>{
                    triggerRef(element);
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    triggerProps.ref(element);
                },
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen)
            }),
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "dev-panel-create-pull-request-content",
                packageName: "jira-development-summary-branch",
                fallback: null,
                runtimeProps: runtimeProps
            })
    });
};
var $00afeaf6fc3b48d5$export$2e2bcd8739ae039 = $00afeaf6fc3b48d5$var$CreatePullRequestDropdown;

});
parcelRegister("iomkm", function(module, exports) {

$parcel$export(module.exports, "createPullRequestDropdownContentEntrypoint", () => $9a08c67c29c9d346$export$179206df5d8714a6);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $9a08c67c29c9d346$export$179206df5d8714a6 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("i6qhx")), {
        moduleId: "2568e86a",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("i6qhx", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("bNZCp").then(()=>parcelRequire('8qSJe'));

});




$parcel$global.rlb("lOPFD")
//# sourceMappingURL=create-pull-request-dropdown.e8cbd5c4.js.map
